module.exports = __webpack_public_path__ + "static/media/eg.d89ba362.svg";